var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isMobile
    ? _c(
        "div",
        {
          staticClass: "mt-3",
          staticStyle: {
            border: "1px solid #228FEF",
            "background-color": "#E9F5FF",
            "border-radius": "5px",
            "font-size": "12px",
            "text-align": "center",
            padding: "5px 80px 5px 80px",
          },
        },
        [
          _c("div", [
            _vm._v(
              "Na etapa de pagamento você pode efetuar apenas " +
                _vm._s(_vm.$props.porcentagemParcial) +
                "% (" +
                _vm._s(_vm.totalPagamentoParcial) +
                ") do valor para garantir sua reserva"
            ),
          ]),
        ]
      )
    : _c(
        "div",
        {
          staticClass: "px-3 py-2",
          staticStyle: {
            "background-color": "#E9F5FF",
            "font-size": "12px",
            color: "#425D75",
            "text-align": "left",
          },
        },
        [
          _c("div", [
            _c("strong", [
              _vm._v(
                "Na etapa de pagamento você pode efetuar apenas " +
                  _vm._s(_vm.$props.porcentagemParcial) +
                  "% (" +
                  _vm._s(_vm.totalPagamentoParcial) +
                  ") do valor para garantir sua reserva"
              ),
            ]),
          ]),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }